function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  filter: "url(#EmptyStateHubspot_svg__filter0_d_1354_24068)"
}, React.createElement("rect", {
  x: 2,
  width: 32,
  height: 32,
  rx: 8,
  fill: "#fff"
}), React.createElement("rect", {
  x: 2.5,
  y: 0.5,
  width: 31,
  height: 31,
  rx: 7.5,
  stroke: "#E1E9F0"
}));

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.452 8.385H18v15.23h-3.548c-1.414 0-1.927-.147-2.444-.423a2.882 2.882 0 01-1.2-1.2c-.276-.517-.423-1.03-.423-2.444v-7.095c0-1.415.147-1.928.424-2.445a2.883 2.883 0 011.199-1.2c.517-.276 1.03-.423 2.444-.423z",
  fill: "#148CFC"
});

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M18 8.385h3.548c1.414 0 1.927.147 2.444.424.517.276.923.682 1.2 1.199.276.517.423 1.03.423 2.445V16H18V8.385z",
  fill: "#4DB1FD"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.615 16v3.548c0 1.414-.147 1.927-.423 2.444a2.884 2.884 0 01-1.2 1.2c-.517.276-1.03.423-2.444.423H18V16h7.615z",
  fill: "#F2FAFE"
});

var _ref5 =
/*#__PURE__*/
React.createElement("path", {
  d: "M36 16h12",
  stroke: "#E1E9F0",
  strokeWidth: 2,
  strokeLinejoin: "round",
  strokeDasharray: "1 3"
});

var _ref6 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M59 25a9 9 0 119-9 9 9 0 01-9 9zm4.5-10.5h-9a.75.75 0 010-1.5h9a.75.75 0 010 1.5zM56 16h6a.75.75 0 010 1.5h-6a.75.75 0 010-1.5zm1.5 3h3a.75.75 0 010 1.5h-3a.75.75 0 010-1.5z",
  fill: "url(#EmptyStateHubspot_svg__paint0_linear_1354_24068)"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M70 16h12",
  stroke: "#E1E9F0",
  strokeWidth: 2,
  strokeLinejoin: "round",
  strokeDasharray: "1 3"
});

var _ref8 =
/*#__PURE__*/
React.createElement("g", {
  filter: "url(#EmptyStateHubspot_svg__filter1_d_1354_24068)"
}, React.createElement("rect", {
  x: 84,
  width: 32,
  height: 32,
  rx: 8,
  fill: "#fff"
}), React.createElement("rect", {
  x: 84.5,
  y: 0.5,
  width: 31,
  height: 31,
  rx: 7.5,
  stroke: "#E1E9F0"
}));

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M104.201 10.783v2.144a4.695 4.695 0 011.788 8.623 4.695 4.695 0 01-5.357-.258l-1.742 1.742c.045.142.07.29.071.44a1.527 1.527 0 11-1.528-1.529c.15.002.298.026.44.072l1.76-1.76a4.689 4.689 0 01-.07-5.283l-5.79-4.503a1.84 1.84 0 01-.915.248 1.86 1.86 0 111.861-1.856 1.841 1.841 0 01-.066.463l5.879 4.579a4.669 4.669 0 012.222-.978v-2.144a1.651 1.651 0 01-.952-1.488v-.05c0-.91.739-1.65 1.651-1.65h.05c.911 0 1.65.74 1.65 1.65v.05a1.651 1.651 0 01-.952 1.488zm-3.129 6.782a2.41 2.41 0 002.407 2.41h.003a2.41 2.41 0 10-2.41-2.41z",
  fill: "#FF7A59"
});

var _ref10 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("filter", {
  id: "EmptyStateHubspot_svg__filter0_d_1354_24068",
  x: 0,
  y: 0,
  width: 36,
  height: 36,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), React.createElement("feOffset", {
  dy: 2
}), React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.482886 0 0 0 0 0.544786 0 0 0 0 0.599808 0 0 0 0.08 0"
}), React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1354_24068"
}), React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1354_24068",
  result: "shape"
})), React.createElement("filter", {
  id: "EmptyStateHubspot_svg__filter1_d_1354_24068",
  x: 82,
  y: 0,
  width: 36,
  height: 36,
  filterUnits: "userSpaceOnUse",
  colorInterpolationFilters: "sRGB"
}, React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
  result: "hardAlpha"
}), React.createElement("feOffset", {
  dy: 2
}), React.createElement("feGaussianBlur", {
  stdDeviation: 1
}), React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), React.createElement("feColorMatrix", {
  values: "0 0 0 0 0.482886 0 0 0 0 0.544786 0 0 0 0 0.599808 0 0 0 0.08 0"
}), React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1354_24068"
}), React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1354_24068",
  result: "shape"
})), React.createElement("linearGradient", {
  id: "EmptyStateHubspot_svg__paint0_linear_1354_24068",
  x1: 50,
  y1: 7,
  x2: 50,
  y2: 25,
  gradientUnits: "userSpaceOnUse"
}, React.createElement("stop", {
  stopColor: "#4EDC9F"
}), React.createElement("stop", {
  offset: 1,
  stopColor: "#1DC463"
})));

var SvgEmptyStateHubspot = function SvgEmptyStateHubspot(props) {
  return React.createElement("svg", _extends({
    width: 118,
    height: 36,
    viewBox: "0 0 118 36",
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10);
};

export default SvgEmptyStateHubspot;